import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'select-date-modal',
  templateUrl: './select-date-modal.component.html',
  styleUrls: ['./select-date-modal.component.css']
})
export class SelectDateModalComponent implements OnInit {

 
  start?: NgbDateStruct = null;

  end?: NgbDateStruct = null;

  startDate: Date = null;

  endDate: Date = null;

  date: any = null;

  confirmText: string = 'Suche';

  constructor(
    public modal: NgbActiveModal, private toast: ToastrService
  ) {}

  ngOnInit(){}

  updateStart() {
    if (this.start) {
      this.startDate = new Date(this.start.year, this.start.month - 1, this.start.day);
    }
  }

  updateEnd() {
    if (this.end) {
      this.endDate = new Date(this.end.year, this.end.month - 1, this.end.day)
    }
  }

  clickSearch() {
    let returnStart = null;
    let returnEnd = null;
    if (this.start) {
      returnStart = new Date(this.start.year, this.start.month - 1, this.start.day);
    }
  
    if (this.end) {
      returnEnd = new Date(this.end.year, this.end.month - 1, this.end.day);
    }

    this.modal.close({
      start: returnStart,
      end: returnEnd
    });
  }

}
